import React, { useEffect, useRef } from 'react';

interface DropdownMenuProps {
	children: React.ReactNode;
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
	children,
	setIsOpen
}) => {
	const dropdownRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () =>
			document.removeEventListener('mousedown', handleClickOutside);
	}, [setIsOpen]);

	return (
		<div className='relative' ref={dropdownRef}>
			{children}
		</div>
	);
};
